import { render, staticRenderFns } from "./notopen.vue?vue&type=template&id=0933ae4b&scoped=true"
import script from "./notopen.vue?vue&type=script&lang=js"
export * from "./notopen.vue?vue&type=script&lang=js"
import style0 from "./notopen.vue?vue&type=style&index=0&id=0933ae4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933ae4b",
  null
  
)

export default component.exports